// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')
require('../site_scripts/mtc_lazy_load_recaptcha_form')
require('../site_scripts/mtc_file_upload')

require('../../../../core/js/plugins/mtc_slick')

require('../careers-landing/filter')
require('../careers-landing/featured-jobs-slider')
require('../careers-landing/featured-jobs-toggle')
require('../careers-landing/job-form-submit')
require('../careers-landing/init')
require('../../../../core/js/plugins/mtc_cookies');

// elec hub landing specific styles
require('../../styles/entry/careers-landing.less')
